export default "__VITE_ASSET__deb13efd__"